import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Calendar, ArrowRight, Newspaper, ChevronRight } from 'lucide-react';
import no_image_available from '../images/no_image_available.jpg';

function Clproduct() {
    const [newsList, setNews] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const urlImg = `${process.env.REACT_APP_BASEURL}/berita/`;

    useEffect(() => {
        const fetchNews = async () => {
            setIsLoading(true);
            try {
                const response = await fetch(`${process.env.REACT_APP_API_ENDPOINT}/news/berita`);
                const datas = await response.json();
                setNews(datas.data.data || []);
            } catch (error) {
                console.error('Error fetching news:', error);
            } finally {
                setIsLoading(false);
            }
        };
        fetchNews();
    }, []);

    // Format date
    const formatDate = (dateString) => {
        if (!dateString) return '';
        const options = { year: 'numeric', month: 'short', day: 'numeric' };
        return new Date(dateString).toLocaleDateString('id-ID', options);
    };

    // Truncate text
    const truncateText = (text, maxLength = 60) => {
        if (!text) return '';
        return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
    };

    return (
        <div className="w-full bg-gradient-to-br from-blue-50 via-white to-purple-50 py-12 px-4">
            <div className="max-w-7xl mx-auto">
                {/* Header Section */}
                <div className="text-center mb-10">
                    <div className="flex items-center justify-center gap-3 mb-3">
                        <Newspaper className="w-8 h-8 text-[#0889c1]" />
                        <h1 className="text-3xl md:text-4xl font-bold" style={{ fontFamily: 'MuseoSansRounded900' }}>
                            <span className="text-[#0889c1]">BERITA</span>
                            <span className="text-gray-700"> TERBARU</span>
                        </h1>
                    </div>
                    <div className="w-24 h-1 bg-gradient-to-r from-[#0889c1] to-purple-500 mx-auto rounded-full"></div>
                    <p className="mt-4 text-gray-600 text-sm font-medium">
                        Informasi terbaru dan terkini seputar JDIH Kota Magelang
                    </p>
                </div>

                {/* Loading State */}
                {isLoading ? (
                    <div className="flex justify-center items-center h-64">
                        <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-[#0889c1]"></div>
                    </div>
                ) : (
                    <>
                        {/* News Grid */}
                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
                            {newsList.length > 0 ? (
                                newsList.map((field, index) => (
                                    <div
                                        key={index}
                                        className="group bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2"
                                    >
                                        <Link to={`/detail-berita/${field.id}/${field.link}`} className="block">
                                            {/* Image Container */}
                                            <div className="relative overflow-hidden h-56 bg-gray-100">
                                                {field.images ? (
                                                    <img
                                                        src={urlImg + field.images}
                                                        alt={field.nama}
                                                        className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                                                        loading="lazy"
                                                        onError={(e) => {
                                                            e.target.onerror = null;
                                                            e.target.src = no_image_available;
                                                        }}
                                                    />
                                                ) : (
                                                    <img
                                                        src={no_image_available}
                                                        alt="No image available"
                                                        className="w-full h-full object-cover"
                                                    />
                                                )}

                                                {/* Gradient Overlay */}
                                                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>

                                                {/* Date Badge */}
                                                {field.tgl && (
                                                    <div className="absolute top-3 left-3">
                                                        <span className="flex items-center gap-1.5 px-3 py-1.5 bg-white/90 backdrop-blur-sm text-gray-700 text-xs font-semibold rounded-lg shadow-lg">
                                                            <Calendar className="w-3 h-3 text-[#0889c1]" />
                                                            {formatDate(field.tgl)}
                                                        </span>
                                                    </div>
                                                )}
                                            </div>

                                            {/* Content */}
                                            <div className="p-5">
                                                <h3 className="font-bold text-gray-800 text-sm leading-snug line-clamp-3 hover:text-[#0889c1] transition-colors duration-200"
                                                    style={{ fontFamily: 'MuseoSansRounded700' }}>
                                                    {truncateText(field.nama, 70)}
                                                </h3>

                                                {/* Read More Link */}
                                                <div className="mt-3 flex items-center text-[#0889c1] text-xs font-semibold opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                                                    <span>Baca Selengkapnya</span>
                                                    <ChevronRight className="w-4 h-4 ml-1 transform group-hover:translate-x-1 transition-transform duration-200" />
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                ))
                            ) : (
                                // Empty State
                                <div className="col-span-full text-center py-16 bg-white rounded-2xl shadow-lg">
                                    <Newspaper className="w-20 h-20 text-gray-300 mx-auto mb-4" />
                                    <h3 className="text-xl font-bold text-gray-700 mb-2">Belum Ada Berita</h3>
                                    <p className="text-gray-500">Belum ada berita yang tersedia saat ini</p>
                                </div>
                            )}
                        </div>

                        {/* View All Button */}
                        {newsList.length > 0 && (
                            <div className="mt-12 text-center">
                                <Link to="/berita">
                                    <button className="group inline-flex items-center gap-2 px-8 py-3.5 bg-gradient-to-r from-[#0889c1] to-purple-600 text-white text-sm font-semibold rounded-full shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105">
                                        <span>Lihat Semua Berita</span>
                                        <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform duration-200" />
                                    </button>
                                </Link>
                            </div>
                        )}
                    </>
                )}
            </div>
        </div>
    );
}

export default Clproduct;